import * as Yup from 'yup'

export const jobtypeSchema = Yup.object({
    job_type:Yup.string().required('INPUT.VALIDATION.JOBTYPE.REQUIRED'),
    rate: Yup.number().required("INPUT.VALIDATION.RATE.REQUIRED").min(0).positive("INPUT.VALIDATION.RATE.POSITIVE"),
    additional_information:Yup.string()
})